/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Board_MoreInputs */

const en_directory_home_board_more = /** @type {(inputs: Directory_Home_Board_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More launches to browse`)
};

const zh_directory_home_board_more = /** @type {(inputs: Directory_Home_Board_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更多值得一看的发布`)
};

/**
* | output |
* | --- |
* | "More launches to browse" |
*
* @param {Directory_Home_Board_MoreInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_board_more = /** @type {((inputs?: Directory_Home_Board_MoreInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Board_MoreInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_board_more(inputs)
	return zh_directory_home_board_more(inputs)
});
export { directory_home_board_more as "directory.home.board.more" }